import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { useCancelInvoiceMutation } from '~entities/student/api/payments/cancel-invoice';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '~shared/shadcn/ui/alert-dialog';
import { Button } from '~shared/shadcn/ui/button';
import { DropdownMenuItem } from '~shared/shadcn/ui/dropdown-menu';

interface CancelInvoiceProps {
  invoiceId: string;
  studentId?: string;
}

export const CancelInvoice = ({ invoiceId, studentId }: CancelInvoiceProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync: cancelInvoice, isPending } = useCancelInvoiceMutation();

  const handleCancelInvoice = async () => {
    try {
      await cancelInvoice({ invoiceId: [invoiceId], studentId });
      toast.success('Invoice cancelled successfully');
    } catch (error) {
      console.error(error);
      toast.error('Failed to cancel invoice');
    } finally {
      setIsOpen(false);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger asChild>
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault();
          }}
        >
          Cancel Invoice
        </DropdownMenuItem>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Invoice</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to cancel this invoice? This action cannot be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <Button onClick={handleCancelInvoice} disabled={isPending}>
            {isPending && <Loader2 className='animate-spin' />}
            Continue
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
